import React, { Fragment, useContext, useState } from 'react'
import Tip from 'app/React/Components/misc/Tip'
import { validateSteps } from 'app/React/Helpers/StepHelper'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function PaymentRadio(props) {
  const {
    currentVariant,
    isDealerConfigurator,
    order,
    setOrder,
    setValidSteps
  } = useContext(ConfiguratorContext)

  const [visibleChildren, setVisibleChildren] = useState(order[props.name] === props.visibleChildrenValue)

  const initial_value = typeof order[props.name] !== 'undefined' ? order[props.name] : ''

  const onchange = function (value) {
    order[props.name] = value
    setOrder({ ...order })

    setValidSteps(validateSteps(currentVariant.steps, order, isDealerConfigurator, currentVariant))

    if (typeof props.showChildren === 'function') {
      setVisibleChildren(props.showChildren(value))
    } else {
      setVisibleChildren(value === 'yes')
    }
  }

  const options = function () {
    const options = props.options
    return options.map((key, index) => (
      <Fragment key={index}>
        <input
          onChange={() => onchange(options[index].value)}
          type='radio'
          name={props.name}
          id={['paymentradio_', props.name, options[index].value].join('_')}
          value={options[index].value}
          checked={initial_value === options[index].value}
        />
        <label
          htmlFor={['paymentradio_', props.name, options[index].value].join('_')}
          className='config-radio__radio'
          layout={props.optionLayout}
        >
          {options[index].label}
          <div className='description'>{options[index].description}</div>
        </label>
      </Fragment>
    ))
  }

  return (
    <>
      <h2 className='config-form__subtitle'>
        {props.title}
        {typeof props.tip === 'string' && props.tip.length > 0 ? <Tip content={props.tip}/> : null}
      </h2>
      {
        typeof props.description === 'string' && props.description.length > 0
          ? <div className='description'>{props.description}</div>
          : null
      }
      <div className='config-radio'>{options()}</div>
      {visibleChildren ? props.children : null}
      <div className='config-form__separator'/>
    </>
  )
}

PaymentRadio.defaultProps = {
  tip: null,
  visibleChildren: false,
  optionLayout: 'standard',
  visibleChildrenValue: 'yes'
}
